import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
// import { initGoogleAnalytics } from './gtag';

if (environment.production) {
  enableProdMode();
  // initGoogleAnalytics();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  // .then(success => console.log('Boostrap success'))
  .catch(err => console.log(err));
